// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1___9513dde4b3ab9bdcc00{/*!*/}.ResearchInterestTags-cls2__cdb78753dd1d92acd47a{display:flex;flex-wrap:wrap;align-content:flex-start;padding:10px;height:133px;overflow-x:hidden;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1___9513dde4b3ab9bdcc00",
	"cls2": "ResearchInterestTags-cls2__cdb78753dd1d92acd47a ResearchInterestTags-cls1___9513dde4b3ab9bdcc00"
};
export default ___CSS_LOADER_EXPORT___;
